
import "./home_page.css";
import NavbarHome from "../../../components/nav/nav_home";
import AboutContainer from "../../../components/home/about/about";
import ProductContainer from "../../../components/home/products/products";
import CostContainer from "../../../components/home/cost/cost";
import FAQContainer from "../../../components/home/faq/faq";
import { useNavigate } from "react-router-dom";

const HomePageMain = () => {

    const navigate = useNavigate();

    const navigateToTerms = () => {
        navigate("/terms_of_service");
    }

    const navigateToPrivacy = () =>{
        navigate("/privacy_policy");
    }

    const navigateToHome = () =>{
        navigate("/");
    }

    const scrollTo = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      };
  
    return (
    <div className="homepage-whole-outer">
        <div className="homepage-whole">
            <div>
                {<NavbarHome/>}
                <div className="homepage-content-container">
                    {<section id="about" style={{height:"650px"}}>
                        <div style={{height:"650px"}}>
                            
                            <AboutContainer/>
                        </div>
                    </section>}
                    {<div style={{height:"775px", width:"100%"}}>
                        <section id="products" style={{height:"775px"}}>
                            <ProductContainer/>
                        </section>
                    </div>}
                    {<div style={{height:"850px", width:"100%"}}>
                        <section id="cost" style={{height:"850px"}}>
                            <CostContainer/>
                        </section>
                    </div>}
                    {<div style={{height:"625px"}}>
                        <section id="faq" style={{height:"625px"}}>
                            <FAQContainer/>
                        </section>
                    </div>}
                </div>
            </div>
        </div>
        {<div className="footer-container">
            <p onClick={() => scrollTo("about")}className="footer-brand">Stock Archives LLC</p>
            <p onClick={navigateToTerms}  className="footer-other-right">Terms Of Use</p>
            <p onClick={navigateToPrivacy} className="footer-other-left">Privacy Policy</p>
        </div>}
      </div>
    );
  };
  
  export default HomePageMain;